import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AppointmentRequest } from '../../../services/rest-api.service';

@Component({
  selector: 'app-appointment-details',
  templateUrl: './appointment-details.component.html'
})
export class AppointmentDetailsComponent implements OnInit {
  @Input() title;
  @Input() appointmentRequest: AppointmentRequest;

  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {
    this.title = 'Appointment Details';
  }

  close(requestType) {
    this.appointmentRequest.requestType = requestType;
    this.modal.close(this.appointmentRequest);
  }
}
